import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
  colors: {
    gray: {
      700: '#1f2733',
    },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: mode('gray.50', 'gray.800')(props),
        fontFamily: "'Roboto', sans-serif",
        overflowX: 'auto', // Enables horizontal scrolling
      },
      html: {
        fontFamily: "'Roboto', sans-serif",
      },
      // Custom scrollbar styles
      '::-webkit-scrollbar': {
        height: '8px', // Height of the horizontal scrollbar
        width: '8px', // Width of the vertical scrollbar
      },
      '::-webkit-scrollbar-track': {
        background: 'transparent', // Background of the scrollbar track
      },
      '::-webkit-scrollbar-thumb': {
        background: 'linear-gradient(134.23deg, #071D54 14.41%, #A1B8D9 85.58%)', // Darker color at the top
        borderRadius: '10px', // Round edges for the thumb
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: 'linear-gradient(134.23deg, #3A4B70 14.41%, #071D54 85.58%)', // Lighter gradient on hover
      },
      '::-moz-scrollbar': {
        height: '8px', // Height of the horizontal scrollbar
        width: '8px', // Width of the vertical scrollbar
      },
      '::-moz-scrollbar-track': {
        background: 'transparent',
      },
      '::-moz-scrollbar-thumb': {
        background: 'linear-gradient(134.23deg, #071D54 14.41%, #A1B8D9 85.58%)',
        borderRadius: '10px',
      },
      '::-moz-scrollbar-thumb:hover': {
        background: 'linear-gradient(134.23deg, #3A4B70 14.41%, #071D54 85.58%)',
      },
    }),
  },
};
